import React from 'react'
import EyefinitySectionFields from '../EyefinitySectionFields'

export default function Lab(props) {
  return <EyefinitySectionFields {...props} sectionName="lab" title="Lab" />
}
